/*
 * 1DS JS SDK Properties plugin, 3.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* AITrace.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { getLocation, generateW3CId } from "@microsoft/1ds-core-js";
var Trace = /** @class */function () {
  function Trace(propertiesConfig, id, parentId, name) {
    if (propertiesConfig.enableApplicationInsightsTrace) {
      this.traceId = id || generateW3CId();
      this.parentId = parentId;
      this.name = name;
      var loc = getLocation();
      if (loc && loc.pathname) {
        this.name = loc.pathname;
      }
    }
  }
  return Trace;
}();
export { Trace };